export const SendIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
        >
            <path
                d="M9.03333 3.3168L9.68226 3.96802L6.83111 8.04382L8.25991 12.3296C8.30077 12.452 8.41533 12.5337 8.54306 12.5331C8.672 12.5323 8.78522 12.449 8.82422 12.3275L8.82434 12.3272L12.5187 0.85523C12.553 0.748737 12.5247 0.632193 12.4462 0.553747C12.3678 0.47537 12.2514 0.447057 12.1449 0.481238C12.1448 0.48125 12.1448 0.481262 12.1448 0.481275L0.672825 4.17566L0.672455 4.17578C0.551002 4.21478 0.467677 4.32798 0.46695 4.45691L9.03333 3.3168ZM9.03333 3.3168L4.93541 6.16196M9.03333 3.3168L4.93541 6.16196M4.93541 6.16196L0.670368 4.74009C0.670316 4.74007 0.670263 4.74006 0.670211 4.74004C0.547966 4.69913 0.466267 4.58461 0.46695 4.45694L4.93541 6.16196Z"
                fill="white"
                stroke="white"
                stroke-width="0.933891"
            />
        </svg>
    );
};
